import { addFavoriteRide, removeFavoriteRide } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var toFavoritesFetchers = function toFavoritesFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    AddFavorite: toFetcher(function (_, _ref) {
      var rideId = _ref.rideId;
      return "AddFavorite:".concat(rideId);
    }, function (req, opt) {
      return unwrap(function () {
        return addFavoriteRide(api, {
          rideId: opt.rideId
        }, req.pelotonPlatform);
      });
    }),
    RemoveFavorite: toFetcher(function (_, _ref2) {
      var rideId = _ref2.rideId;
      return "RemoveFavorite:".concat(rideId);
    }, function (req, opt) {
      return unwrap(function () {
        return removeFavoriteRide(api, {
          rideId: opt.rideId
        }, req.pelotonPlatform);
      });
    })
  };
};